// extracted by mini-css-extract-plugin
export default {"orderTrackingCard":"OrderTracking_orderTrackingCard__2mNxc","numbers":"OrderTracking_numbers__rACWU","box":"OrderTracking_box__d3SBs","active":"OrderTracking_active__+Gd6r"};